<template>
  <ux-form
    ref="form"
    :data="formData"
    width="720px"
    :colon="true"
    :rules="rules"
    label-width="90px"
    data-automation="addGroup"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.addUserGroup.name')" required prop="group_name">
      <ux-input
        v-model.trim()="formData.group_name"
        :maxlength="10"
        :placeholder="$t('HT.pleaseInput')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" start prop="remark">
      <ux-input
        v-model.trim()="formData.remark"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 5 }"
        resize="none"
        :maxlength="180"
        show-word-limit
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          group_name: '',
          remark: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addUserGroup()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
